import type {ISearchComboboxIconProps} from "@pg-design/search-combobox-module";

/** Street icon (a signpost), 20px - street rows. */
export const PricesSearchStreetIcon = (props: ISearchComboboxIconProps) => {
    const {size = 20, className, dataTestId} = props;

    return (
        <svg className={className} data-testid={dataTestId} width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">
            <path d="M10 10.8333V17.5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 2.5V5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M3.33333 5C3.11232 5 2.90036 5.0878 2.74408 5.24408C2.5878 5.40036 2.5 5.61232 2.5 5.83333V10C2.5 10.221 2.5878 10.433 2.74408 10.5893C2.90036 10.7455 3.11232 10.8333 3.33333 10.8333H14.1667C14.5104 10.8334 14.8457 10.7271 15.1267 10.5292L17.98 8.59833C18.0892 8.52141 18.1783 8.41937 18.2398 8.30081C18.3013 8.18225 18.3334 8.05065 18.3334 7.91708C18.3334 7.78352 18.3013 7.65192 18.2398 7.53336C18.1783 7.4148 18.0892 7.31276 17.98 7.23583L15.1267 5.30417C14.8457 5.10622 14.5104 4.99998 14.1667 5H3.33333Z"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
import type {ISearchComboboxIconProps} from "@pg-design/search-combobox-module";

/** Street icon (a signpost), 20px - street rows. */
export const PricesSearchStreetIcon = (props: ISearchComboboxIconProps) => {
    const {size = 20, className, dataTestId} = props;

    return (
        <svg className={className} data-testid={dataTestId} width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">
            <path d="M10 10.8333V17.5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 2.5V5" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M3.33333 5C3.11232 5 2.90036 5.0878 2.74408 5.24408C2.5878 5.40036 2.5 5.61232 2.5 5.83333V10C2.5 10.221 2.5878 10.433 2.74408 10.5893C2.90036 10.7455 3.11232 10.8333 3.33333 10.8333H14.1667C14.5104 10.8334 14.8457 10.7271 15.1267 10.5292L17.98 8.59833C18.0892 8.52141 18.1783 8.41937 18.2398 8.30081C18.3013 8.18225 18.3334 8.05065 18.3334 7.91708C18.3334 7.78352 18.3013 7.65192 18.2398 7.53336C18.1783 7.4148 18.0892 7.31276 17.98 7.23583L15.1267 5.30417C14.8457 5.10622 14.5104 4.99998 14.1667 5H3.33333Z"
                stroke="currentColor"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
